<template>
  <CustomModal 
    centered 
    :show="showModal"
    @closeModal="$emit('close')"
    @shown="$refs.username.focus()">
    <template #modal-header>
      Authorization
    </template>
    <template #modal-body>
      <b-form>
        <b-form-group
          label="Username">
          <b-form-input 
            debounce="500"
            v-model="username"
            ref="username" />
        </b-form-group>
        <b-form-group
          label="Password">
          <b-form-input
            debounce="500"
            v-model="password"
            type="password" />
        </b-form-group>
      </b-form>
    </template>
    <template #modal-footer>
      <div class="button-footer">
        <SaveButton 
          label="Ok"
          @click="onAuthorizeUser()"/>
        <CloseButton @click="$emit('close')" class="ml-2"/>
      </div>
    </template>
  </CustomModal>
</template>
<script>
import { AuthApi } from '../../mixins/api'
import { CustomModal, CloseButton, SaveButton } from './'
export default {
  components: {
    CustomModal,
    CloseButton,
    SaveButton
  },
  mixins: [AuthApi],
  props: {
    show: Boolean,
  },
  data() {
    return {
      username: null,
      password: null
    }
  },
  methods: {
    onAuthorizeUser() {
      const data = {
        username: this.username,
        password: this.password
      }

      this.checkIfAuthorize(data)
      .then(({ data }) => {
        console.log(data)
        this.$emit('authorize', data)
      }).catch(error => {
        console.log(error)
        this.$emit('authorize', false)
      })
      
    }
  },
  computed: {
    showModal: {
      get: function() {
        this.username = null
        this.password = null 
        return this.show
      },
      set: function(newValue) {
        this.username = null
        this.password = null 
        return newValue
      }
    }
  }
}
</script>